module.exports = __webpack_public_path__ + "media/images/bg_greenPattern-e843f0a4.jpg";